var map = {
	"./aprovavp/horizontal-logo.svg": 89335,
	"./backupDemo/horizontal-logo.svg": 45355,
	"./brasilstartups/horizontal-logo.svg": 75957,
	"./caboverde/horizontal-logo.svg": 90127,
	"./canaleducacao/horizontal-logo.svg": 64064,
	"./demo/horizontal-logo.svg": 39905,
	"./egepi/horizontal-logo.svg": 1322,
	"./encceja/horizontal-logo.svg": 32149,
	"./fic/horizontal-logo.svg": 92820,
	"./iesb/horizontal-logo.svg": 81885,
	"./inkluziva/horizontal-logo.svg": 24903,
	"./maiseducacao/horizontal-logo.svg": 29601,
	"./oab/horizontal-logo.svg": 54736,
	"./oros/horizontal-logo.svg": 89933,
	"./pit/horizontal-logo.svg": 73629,
	"./powerforgirls/horizontal-logo.svg": 41551,
	"./quartosecretariado/horizontal-logo.svg": 81195,
	"./retina/horizontal-logo.svg": 28949,
	"./seducpi/horizontal-logo.svg": 13331,
	"./sett-solutions/horizontal-logo.svg": 7587,
	"./siape/horizontal-logo.svg": 18390,
	"./tjpara/horizontal-logo.svg": 98356,
	"./unisescoop/horizontal-logo.svg": 59094,
	"./vegalabs/horizontal-logo.svg": 9563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89854;